import { isOutMessage } from 'apps/chat/components/ChatMessage/helpers/messageHelpers'
import { EMPTY_ARRAY } from 'shared/constants/empty'

import { InstagramOutMessage } from '../models/chatInterfaces'

export const getMessagesMap = (state: RootState) => state.chat.messages.byId

export const getMessagesList = (state: RootState) => state.chat.messages.items ?? EMPTY_ARRAY

export const canFetchEarlyMessages = (state: RootState) =>
  state.chat.messages.listEarlyLimiter !== null

export const canFetchLaterMessages = (state: RootState) =>
  state.chat.messages.listLaterLimiter !== null

export const getScrollDisabled = (state: RootState) => state.chat.messages?.scrollDisabled

export const getById = (state: RootState, id: number) => {
  const map = getMessagesMap(state)
  return map[id]
}

export const isSomeMessageSending = (state: RootState) => {
  const list = getMessagesList(state) || []
  return list.some((m) => m.sending)
}

export const getInstagramMessageByMID = (state: RootState, mid?: string) => {
  const messages = getMessagesList(state) || []
  if (!mid) return null

  return messages.find((message) => {
    if (isOutMessage(message)) {
      return (
        'model' in message &&
        'messages' in message.model &&
        message.model.messages?.find((outMessage: InstagramOutMessage) => outMessage._mid === mid)
      )
    } else {
      return 'model' in message && 'mid' in message.model && message.model?.mid === mid
    }
  })
}

export const getHideAutomation = (state: RootState) => state.chat.messages.hideAutomation
